import {makeStyles} from '@material-ui/core'

// @ts-ignore
export default makeStyles(theme => ({
  root: {
    borderRadius: 0,
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: theme.spacing(1.5),
    paddingLeft: theme.spacing(3),
    cursor: 'pointer',
  },
  container: {
    position: 'relative',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  button: (props: any) => ({
    textTransform: 'none',
    borderLeft: props.selected ? `7px solid ${theme.palette.primary.main}` : '',
  }),
  typography: (props: any) => ({
    fontWeight: props.selected
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightLight,
  }),
}))
